export const PROSPECTUS_SERVICE_TYPE_ID = 6;
export const STATEMENTS_SERVICE_TYPE_ID = 8;
export const CONFIRMATIONS_SERVICE_TYPE_ID = 70;
export const AK_STATEMENTS_SERVICE_TYPE_ID = 80;
export const AK_CONFIRMATIONS_SERVICE_TYPE_ID = 81;
export const NAT_STATEMENTS_SERVICE_TYPE_ID = 82;
export const NAT_CONFIRMATIONS_SERVICE_TYPE_ID = 83;
export const MD_STATEMENTS_SERVICE_TYPE_ID = 90;
export const MD_CONFIRMATIONS_SERVICE_TYPE_ID = 91;
export const PROXY_SERVICE_TYPE_ID = 97;
export const AK_PDD_SERVICE_TYPE_ID = 104;
export const NAT_PDD_SERVICE_TYPE_ID = 105;
export const MD_PDD_SERVICE_TYPE_ID = 106;
export const TAXFORMS_SERVICE_TYPE_ID = 117;
export const CLIENT_COMM_SERVICE_TYPE_ID = 118;
export const NAT_CLIENT_COMM_SERVICE_TYPE_ID = 119;
export const AK_CLIENT_COMM_SERVICE_TYPE_ID = 120;
export const MD_CLIENT_COMM_SERVICE_TYPE_ID = 121;
export const BR_TAXFORMS_SERVICE_TYPE_ID = 122;
export const BR_PROSPECTUS_SERVICE_TYPE_ID = 123;
export const BR_PROXY_SERVICE_TYPE_ID = 124;
export const BR_CLIENT_COMM_SERVICE_TYPE_ID = 125;
export const AK_TAXFORMS_SERVICE_TYPE_ID = 127;
export const NAT_TAXFORMS_SERVICE_TYPE_ID = 128;
export const MD_TAXFORMS_SERVICE_TYPE_ID = 129;

export const BR_CUSTODY_STATEMENTS_SERVICE_TYPE_ID = 132;
export const ESTATEMENTS_PREFERENCE_IDS = [
  STATEMENTS_SERVICE_TYPE_ID,
  AK_STATEMENTS_SERVICE_TYPE_ID,
  NAT_STATEMENTS_SERVICE_TYPE_ID,
  MD_STATEMENTS_SERVICE_TYPE_ID
];

export const CUSTODY_STATEMENTS_IDS = [
  BR_CUSTODY_STATEMENTS_SERVICE_TYPE_ID
];
export const CONFIRMATIONS_PREFERENCE_IDS = [
  CONFIRMATIONS_SERVICE_TYPE_ID,
  AK_CONFIRMATIONS_SERVICE_TYPE_ID,
  NAT_CONFIRMATIONS_SERVICE_TYPE_ID,
  MD_CONFIRMATIONS_SERVICE_TYPE_ID
];
export const PROSPECTUSES_PREFERENCE_IDS = [
  PROSPECTUS_SERVICE_TYPE_ID,
  BR_PROSPECTUS_SERVICE_TYPE_ID
];
export const PROXY_PREFERENCE_IDS = [PROXY_SERVICE_TYPE_ID, BR_PROXY_SERVICE_TYPE_ID];
export const TAXFORMS_PREFERENCE_IDS = [
  TAXFORMS_SERVICE_TYPE_ID,
  BR_TAXFORMS_SERVICE_TYPE_ID,
  NAT_TAXFORMS_SERVICE_TYPE_ID,
  MD_TAXFORMS_SERVICE_TYPE_ID,
  AK_TAXFORMS_SERVICE_TYPE_ID
];
export const CLIENT_PREFERENCE_IDS = [
  CLIENT_COMM_SERVICE_TYPE_ID,
  NAT_CLIENT_COMM_SERVICE_TYPE_ID,
  AK_CLIENT_COMM_SERVICE_TYPE_ID,
  MD_CLIENT_COMM_SERVICE_TYPE_ID,
  BR_CLIENT_COMM_SERVICE_TYPE_ID
];
export const COLLEGE_PLAN_PREFERENCE_IDS = [
  NAT_PDD_SERVICE_TYPE_ID,
  MD_PDD_SERVICE_TYPE_ID,
  AK_PDD_SERVICE_TYPE_ID
];
export const MUTUAL_PREFERENCE_IDS = [
  STATEMENTS_SERVICE_TYPE_ID,
  CONFIRMATIONS_SERVICE_TYPE_ID,
  PROSPECTUS_SERVICE_TYPE_ID,
  PROXY_SERVICE_TYPE_ID,
  TAXFORMS_SERVICE_TYPE_ID,
  CLIENT_COMM_SERVICE_TYPE_ID
];
export const BROKERAGE_PREFERENCE_IDS = [
  STATEMENTS_SERVICE_TYPE_ID,
  CONFIRMATIONS_SERVICE_TYPE_ID,
  BR_PROSPECTUS_SERVICE_TYPE_ID,
  BR_PROXY_SERVICE_TYPE_ID,
  BR_TAXFORMS_SERVICE_TYPE_ID,
  BR_CLIENT_COMM_SERVICE_TYPE_ID,
  BR_CUSTODY_STATEMENTS_SERVICE_TYPE_ID
];
export const NATIONAL_PREFERENCE_IDS = [
  NAT_STATEMENTS_SERVICE_TYPE_ID,
  NAT_CONFIRMATIONS_SERVICE_TYPE_ID,
  NAT_TAXFORMS_SERVICE_TYPE_ID,
  NAT_CLIENT_COMM_SERVICE_TYPE_ID,
  NAT_PDD_SERVICE_TYPE_ID
];
export const MARYLAND_PREFERENCE_IDS = [
  MD_STATEMENTS_SERVICE_TYPE_ID,
  MD_CONFIRMATIONS_SERVICE_TYPE_ID,
  MD_TAXFORMS_SERVICE_TYPE_ID,
  MD_CLIENT_COMM_SERVICE_TYPE_ID,
  MD_PDD_SERVICE_TYPE_ID
];
export const AK_PREFERENCE_IDS = [
  AK_STATEMENTS_SERVICE_TYPE_ID,
  AK_CONFIRMATIONS_SERVICE_TYPE_ID,
  AK_PDD_SERVICE_TYPE_ID,
  AK_CLIENT_COMM_SERVICE_TYPE_ID,
  AK_TAXFORMS_SERVICE_TYPE_ID
];
export const LABELS = [
  'Custody Statements',
  'Statements',
  'Confirmations',
  'Prospectuses & Shareholder Reports',
  'Proxy Materials',
  'Tax Forms',
  'Client Communications',
  '529 Plan Disclosures'
];

export const LABELS_FOR_PAPERLESS = {
  Statements: ESTATEMENTS_PREFERENCE_IDS,
  Confirmations: CONFIRMATIONS_PREFERENCE_IDS,
  'Prospectuses & Shareholder Reports': PROSPECTUSES_PREFERENCE_IDS,
  'Proxy Materials': PROXY_PREFERENCE_IDS,
  'Tax Forms': TAXFORMS_PREFERENCE_IDS,
  'Client Communications': CLIENT_PREFERENCE_IDS,
  '529 Plan Disclosures': COLLEGE_PLAN_PREFERENCE_IDS,
  'Custody Statements': CUSTODY_STATEMENTS_IDS
};

export const PAPERLESS_OVERVIEW_ENUM = {
  mutualFund: MUTUAL_PREFERENCE_IDS,
  brokerage: BROKERAGE_PREFERENCE_IDS,
  national529: NATIONAL_PREFERENCE_IDS,
  maryland529: MARYLAND_PREFERENCE_IDS,
  alaska529: AK_PREFERENCE_IDS
};
